import { $api } from '@service/RequestService';
import { entranceEndpoints } from '@utils/constants/apis';
import { useQuery } from 'react-query';

import { Entrance, entranceSchema, generateShaxmatka } from 'modules/shaxmatka';

import { IContext } from '../context/context';
import { ENTRANCE } from '../keys';

interface Params {
  blockId: number;
}

export interface IQuery extends Pick<IContext, 'entrances' | 'shaxmatka'> {}

export const useEntrances = ({ blockId }: Params) => {
  const initialValue: IQuery = {
    entrances: [],
    shaxmatka: {
      entrance: {},
      row: { count: 0, list: {} },
      flat: { ids: [], list: {} },
      column: {}
    }
  };

  const { data = initialValue, ...args } = useQuery<IQuery>(
    ENTRANCE.list({ blockId }).queryKey,
    async () => {
      const { data } = await $api.get(entranceEndpoints.INDEX, { params: { buildingId: blockId } });

      const entrances: Entrance[] = (data.data || []).map(entranceSchema.parse);

      const shaxmatka = generateShaxmatka(entrances);

      return { entrances, shaxmatka };
    },
    { enabled: !!blockId, staleTime: 1200000 }
  );

  return { ...data, ...args };
};
